<era-panel>
  <era-panel-header>
    <era-title>
      <span title
            i18n>Settings</span>
    </era-title>

    <ul class="nav nav-tabs-sm border-bottom">
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./wifi']"
           [routerLinkActive]="['active']">WiFi</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./restrictions']"
           [routerLinkActive]="['active']">Restrictions</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./airplay-security']"
           [routerLinkActive]="['active']">Airplay</a>
      </li>
    </ul>
  </era-panel-header>

  <router-outlet></router-outlet>
</era-panel>